import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import withStyles from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';

import ThemeContainer from '@shorelight/ui-common-components/cjs/themes/ThemeContainer';
import Spinner from '@shorelight/ui-common-components/esm/components/progress/Spinner';

import Header from './Header';
import SuccessPage from './SuccessPage';
import SuperFormContainer from './SuperFormComponents/SuperFormContainer';

import { fetchForm } from '../redux/form/form';

import { customThemeStyles } from '../styles/materialTheme';
import { colorPalette } from '../styles/customStyling';

//128 = header height (75) + footer min height (48) + footer margin top (5)
const substractToMinHeight = 128;

const styles = (theme) => ({
  mainContainer: {
    minHeight: `calc(100vh - ${substractToMinHeight}px)`
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  errorContainer: {
    textAlign: 'center',
    paddingTop: theme.spacing(6)
  },
  footerContainer: {
    height: 120,
    [theme.breakpoints.down('xs')]: {
      height: 184
    }
  },
  footerContainerReviewPage: {
    height: 48
  },
  footerContainerOtherPages: {
    height: 'fit-content'
  },
  footerOuterContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 5,
    width: '100%',
    fontSize: 10,
    position: 'relative',
    flexDirection: 'column',
    margin: '0px auto'
  },
  footerInnerContainer: {
    display: 'flex',
    paddingLeft: 0,
    margin: '0px auto'
  },
  footerInnerContainerCentered: {},
  footerDateContainer: {
    opacity: 0.7,
    marginRight: 15
  },
  footerLink: {
    color: colorPalette.slOrange,
    marginLeft: 10,
    marginRight: 10,
    '&:visited': {
      color: colorPalette.slOrange
    }
  }
});

class App extends React.PureComponent {
  componentDidMount() {
    this.props.fetchForm();
  }

  renderContent = () => {
    const { classes, formFetching, formFetchError, formSubmitSuccess, userEmail } = this.props;

    if (formFetching) {
      return <Spinner size="medium" />;
    } else if (formFetchError) {
      return <div className={classes.errorContainer}>{formFetchError.content}</div>;
    } else if (formSubmitSuccess) {
      return <SuccessPage userEmail={userEmail} />;
    } else {
      return <SuperFormContainer />;
    }
  };

  render() {
    const {
      classes,
      formFetching,
      formSubmitSuccess,
      formFetchError,
      reviewingApplication
    } = this.props;
    const mainContainerClasses = classnames(classes.mainContainer, {
      [classes.flexContainer]: formFetching
    });
    const footerContainerClasses = classnames(classes.footerContainer, {
      [classes.footerContainerReviewPage]: reviewingApplication,
      [classes.footerContainerOtherPages]: formFetching || formSubmitSuccess || formFetchError
    });

    return (
      <ThemeContainer theme={customThemeStyles}>
        <CssBaseline />
        <Header />
        <div className={mainContainerClasses}>{this.renderContent()}</div>
        <div className={footerContainerClasses}>
          <div className={classnames(classes.footerOuterContainer)}>
            <div className={classnames(classes.footerInnerContainer)}>
              <div className={classes.footerDateContainer}>
                {`© ${new Date().getFullYear()} Shorelight. All rights reserved.`}
              </div>
              <div>|</div>
              <a
                className={classes.footerLink}
                target="_blank"
                href="https://shorelight.com/pages/terms/"
                rel="noreferrer noopener"
              >
                Terms of Service
              </a>
              <div>|</div>
              <a
                className={classes.footerLink}
                target="_blank"
                href="https://shorelight.com/pages/privacy/"
                rel="noreferrer noopener"
              >
                Privacy & Cookie Notice
              </a>
            </div>
          </div>
        </div>
      </ThemeContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    formFetching: state.customForm.formFetching,
    formFetchError: state.customForm.formFetchError,
    formSubmitSuccess: state.customForm.formSubmitSuccess,
    reviewingApplication: state.application.reviewingApplication,
    userEmail: state.application.values && state.application.values.email
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchForm: () => {
      dispatch(fetchForm());
    }
  };
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(App));
